import { css as v, LitElement as m, html as n, nothing as c } from "lit";
import { query as g, property as o, state as f, customElement as b } from "lit/decorators.js";
import { classMap as y } from "lit/directives/class-map.js";
import { b as w, f as x } from "./styles-scZ6dVz-.js";
import { b as h, a as u } from "./events-CkEPl0SM.js";
import { g as $ } from "./a11y-DxQW21Jt.js";
var S = Object.defineProperty, z = Object.getOwnPropertyDescriptor, r = (t, s, a, l) => {
  for (var i = l > 1 ? void 0 : l ? z(s, a) : s, p = t.length - 1, d; p >= 0; p--)
    (d = t[p]) && (i = (l ? d(s, a, i) : d(i)) || i);
  return l && i && S(s, a, i), i;
};
let e = class extends m {
  constructor() {
    super(...arguments), this.selectId = $("ark-select"), this.value = "", this.options = [], this.size = "md", this.disabled = !1, this.required = !1, this.invalid = !1, this.hasFocus = !1;
  }
  /** Focus the select */
  focus(t) {
    this.selectElement?.focus(t);
  }
  /** Blur the select */
  blur() {
    this.selectElement?.blur();
  }
  handleChange(t) {
    const s = t.target;
    this.value = s.value, h(this, u.CHANGE, { value: this.value });
  }
  handleFocus() {
    this.hasFocus = !0, h(this, u.FOCUS);
  }
  handleBlur() {
    this.hasFocus = !1, h(this, u.BLUR);
  }
  render() {
    const t = {
      wrapper: !0,
      [this.size]: !0,
      disabled: this.disabled,
      invalid: this.invalid,
      focused: this.hasFocus
    }, s = n`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m6 9 6 6 6-6"/>
      </svg>
    `;
    return n`
      <div part="wrapper" class=${y(t)}>
        <span part="prefix" class="prefix">
          <slot name="prefix"></slot>
        </span>

        <select
          part="select"
          id=${this.selectId}
          name=${this.name ?? c}
          ?disabled=${this.disabled}
          ?required=${this.required}
          aria-invalid=${this.invalid ? "true" : c}
          @change=${this.handleChange}
          @focus=${this.handleFocus}
          @blur=${this.handleBlur}
        >
          ${this.placeholder ? n`<option value="" disabled ?selected=${!this.value} class="placeholder">
                ${this.placeholder}
              </option>` : c}
          ${this.options.map(
      (a) => n`
              <option
                value=${a.value}
                ?disabled=${a.disabled}
                ?selected=${a.value === this.value}
              >
                ${a.label}
              </option>
            `
    )}
        </select>

        <span part="icon" class="icon">
          ${s}
        </span>
      </div>
    `;
  }
};
e.styles = [
  w,
  x,
  v`
      :host {
        display: block;
      }

      .wrapper {
        position: relative;
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        background-color: var(--r5-bg);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-md);
        transition-property: border-color, box-shadow;
        transition-duration: var(--r5-duration-fast);
        transition-timing-function: var(--r5-ease-default);
        cursor: pointer;
      }

      .wrapper:focus-within {
        border-color: var(--r5-border-focus);
        box-shadow: 0 0 0 var(--r5-focus-ring-width) var(--r5-color-primary-100);
      }

      .wrapper.invalid {
        border-color: var(--r5-color-danger-500);
      }

      .wrapper.invalid:focus-within {
        box-shadow: 0 0 0 var(--r5-focus-ring-width) var(--r5-color-danger-100);
      }

      .wrapper.disabled {
        background-color: var(--r5-bg-muted);
        opacity: 0.5;
        cursor: not-allowed;
      }

      /* Sizes */
      .sm {
        min-height: var(--r5-input-height-sm);
        padding: 0 var(--r5-space-2);
        font-size: var(--r5-text-xs);
      }

      .md {
        min-height: var(--r5-input-height-md);
        padding: 0 var(--r5-space-3);
        font-size: var(--r5-text-sm);
      }

      .lg {
        min-height: var(--r5-input-height-lg);
        padding: 0 var(--r5-space-4);
        font-size: var(--r5-text-base);
      }

      select {
        flex: 1;
        min-width: 0;
        border: none;
        background: transparent;
        color: var(--r5-text);
        font-family: inherit;
        font-size: inherit;
        outline: none;
        cursor: inherit;
        appearance: none;
        padding-right: var(--r5-space-6);
      }

      select:disabled {
        cursor: not-allowed;
      }

      select option {
        background-color: var(--r5-bg);
        color: var(--r5-text);
      }

      .placeholder {
        color: var(--r5-text-muted);
      }

      .icon {
        position: absolute;
        right: var(--r5-space-3);
        pointer-events: none;
        color: var(--r5-text-muted);
        display: flex;
        align-items: center;
      }

      .icon svg {
        width: 1em;
        height: 1em;
      }

      .prefix {
        display: flex;
        align-items: center;
        color: var(--r5-text-muted);
      }
    `
];
r([
  g("select")
], e.prototype, "selectElement", 2);
r([
  o({ type: String })
], e.prototype, "value", 2);
r([
  o({ type: Array })
], e.prototype, "options", 2);
r([
  o({ type: String })
], e.prototype, "placeholder", 2);
r([
  o({ type: String, reflect: !0 })
], e.prototype, "size", 2);
r([
  o({ type: Boolean, reflect: !0 })
], e.prototype, "disabled", 2);
r([
  o({ type: Boolean, reflect: !0 })
], e.prototype, "required", 2);
r([
  o({ type: Boolean, reflect: !0 })
], e.prototype, "invalid", 2);
r([
  o({ type: String })
], e.prototype, "name", 2);
r([
  f()
], e.prototype, "hasFocus", 2);
e = r([
  b("ark-select")
], e);
export {
  e as A
};
//# sourceMappingURL=ark-select-COD4IWaP.js.map
